import React from "react";
import TextView from "../../TextView";
import { TextContainer } from "./styles";
import CustomLoader from "../../../sharedcomponents/CustomLoader";

export const ReferralProgramAPI = ({ data, isLoading, error }) => {
  if (isLoading) {
    return (
      <TextContainer
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <CustomLoader />
      </TextContainer>
    );
  }

  if (error) {
    return (
      <TextContainer>
        <TextView variant="largeText">
          Error loading Earnings Program terms: {error?.message}
        </TextView>
      </TextContainer>
    );
  }

  const referralProgramData = data?.data?.results?.find(
    (item) => item.slug === "referral_terms"
  );

  if (!referralProgramData) {
    return (
      <TextContainer>
        <TextView variant="largeText">
          Earnings Program content not found.
        </TextView>
      </TextContainer>
    );
  }

  return (
    <TextContainer>
      <div
        dangerouslySetInnerHTML={{
          __html: referralProgramData.body,
        }}
      />
    </TextContainer>
  );
};
